import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetMetaData} from '../hooks/useGetMetaData';
import {GetArticlePageMetaDataResponse} from '../types';

const ArticleStructuredData = ({jsonLd}: GetArticlePageMetaDataResponse) => {
  if (jsonLd == null) {
    return null;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: jsonLd.entities.map(entity => ({
      '@type': 'Question',
      name: entity.name,
      acceptedAnswer: {
        '@type': 'Answer',
        text: entity.answer,
      },
    })),
  };
  return (
    <script
      data-testid="FAQPage"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
};

export const HelpCenterArticleStructuredData = () => {
  return (
    <DataFetcher
      request={useGetMetaData()}
      Error={null}
      View={ArticleStructuredData}
    />
  );
};
